import React, { Component } from 'react';
import cx from 'classnames';
import Input, { INPUT_TYPES } from '../Input/Input';
import './radio_tabs.scss';

class RadioTab extends Component {
  render() {
    return (
      <Input
        {...this.props}
        type={INPUT_TYPES.RADIO}
        labelClassName={cx('block h10 px-4', this.props.labelClassName, {
          'bg-almostWhite': this.props.checked,
        })}
        className={cx(this.props.className, 'radio_tabs__tab')}
      />
    );
  }
}

class RadioTabs extends Component {
  static Tab = RadioTab;

  render() {
    return (
      <div className={cx('flex radio_tabs', this.props.className)}>
        {this.props.children}
      </div>
    );
  }
}

export default  RadioTabs;
